<nav mat-tab-nav-bar>
    <a
        mat-tab-link
        [routerLink]="['gesamt']"
        routerLinkActive
        #lieferantGesamt="routerLinkActive"
        [active]="lieferantGesamt.isActive"
        >Gesamt</a
    >
    <a
        mat-tab-link
        [routerLink]="['einzel']"
        routerLinkActive
        #lieferantEinzel="routerLinkActive"
        [active]="lieferantEinzel.isActive"
        >Einzel</a
    >
</nav>
<router-outlet></router-outlet>
